import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function ResetPasswordSuccessToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t("toasts.reset_password_success.body")}
      id={props.id}
    />
  )
}
